import React, { FunctionComponent } from 'react';
import {
    Modal,
    ModalBody,
    ModalButton,
    ModalFooter,
    ModalHeader,
    ROLE,
    SIZE as M_SIZE,
} from 'baseui/modal';
import { KIND } from 'baseui/button';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import {
    dialogState,
    dialogVisibility,
    dialogValue,
    dialogButtonsText,
} from './AppDialogState';
import { useTranslation } from 'react-i18next';

interface GenericConfirmDialogProps {}

export const AppDialog: FunctionComponent<GenericConfirmDialogProps> = () => {
    const state = useRecoilValue(dialogState);
    const setVisibility = useSetRecoilState(dialogVisibility);
    const setValue = useSetRecoilState(dialogValue);
    const buttonsText = useRecoilValue(dialogButtonsText);
    const { t } = useTranslation();

    return (
        <Modal
            onClose={() => {
                setVisibility(false);
                setValue(false);
            }}
            closeable
            isOpen={state.isVisible}
            animate
            autoFocus
            size={M_SIZE.default}
            role={ROLE.dialog}
        >
            {state.header && <ModalHeader>{state.header}</ModalHeader>}
            <ModalBody>{state.text}</ModalBody>
            <ModalFooter>
                {state.isConfirmMode && (
                    <ModalButton
                        kind={KIND.secondary}
                        onClick={() => {
                            setVisibility(false);
                            setValue(false);
                        }}
                    >
                        {buttonsText.dismiss || t('Cancel')}
                    </ModalButton>
                )}
                <ModalButton
                    onClick={() => {
                        setVisibility(false);
                        setValue(true);
                    }}
                >
                    {buttonsText.accept || t('Ok')}
                </ModalButton>
            </ModalFooter>
        </Modal>
    );
};
